var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFramermotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "3.7 3.7 43.6 43.6",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.3 3.7v21.8l-10.9 10.9-10.9 10.9-10.9-10.9 10.9-10.9v.1-.1z",
    fill: "#59529d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.3 25.5v21.8l-10.9-10.9z",
    fill: "#5271b4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.5 25.5-10.9 10.9-10.9 10.9v-43.6l10.9 10.9z",
    fill: "#bb4b96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramermotion);
export default __webpack_public_path__ + "static/media/framermotion.cd0e8acf350dd639e9e8c999f8539a5e.svg";
export { ForwardRef as ReactComponent };